import {
  CheckIcon,
  DetailsPanel,
  RowCards,
  Typography,
  type RowCardMeta,
} from '@weareopenr/component-library';
import { IBrandResponse } from 'src/api/getBrands/types';
import { Logo } from 'src/components/Logo/Logo';
import styles from './BrandsNeedingAttention.module.scss';

export interface BrandsNeedingAttentionProps {
  brands: IBrandResponse[];
}

interface BrandAttention {
  brand: IBrandResponse;
  reasons: string[];
}

const getAttention = (brands: IBrandResponse[]): BrandAttention[] =>
  brands
    .map((brand) => {
      const reasons: string[] = [];
      if (brand.configured_addons.length === 0) {
        reasons.push('No channels');
      }
      if (brand.venues === 0) {
        reasons.push('No venues');
      }
      return { brand, reasons };
    })
    .filter(({ reasons }) => reasons.length > 0);

export const BrandsNeedingAttention = ({ brands }: BrandsNeedingAttentionProps) => {
  const attention = getAttention(brands);

  const countBadge =
    attention.length > 0 ? (
      <span className={styles.badge} data-testid="attention-count">
        {attention.length}
      </span>
    ) : undefined;

  return (
    <DetailsPanel title="Brands needing attention" action={countBadge}>
      <div className={styles.container}>
        <Typography size="small">Brands missing channels or venues</Typography>

        {attention.length === 0 ? (
          <div className={styles.empty}>
            <span className={styles.emptyIcon}>
              <CheckIcon />
            </span>
            <Typography colour="secondary">All brands have channels and venues set up.</Typography>
          </div>
        ) : (
          <div className={styles.scroll}>
            <RowCards
              rows={attention.map(({ brand, reasons }) => ({
                id: brand.brand_id,
                leading: <Logo src={brand.logo_url} name={brand.name} />,
                title: brand.name,
                meta: reasons.map(
                  (label): RowCardMeta => ({
                    key: `${brand.brand_id}-${label}`,
                    label,
                    colour: 'tomato',
                  }),
                ),
                action: { to: `/brands/${brand.brand_id}`, label: 'View brand' },
              }))}
            />
          </div>
        )}
      </div>
    </DetailsPanel>
  );
};
